(function () {
  document.querySelectorAll('.footer .link-col').forEach(function (col) {
    var trigger = col.querySelector('.accordion-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      var isOpen = col.classList.contains('is-open');

      // Close any other open column (single-open accordion behavior).
      // Remove this block if multiple columns should stay open at once.
      document.querySelectorAll('.footer .link-col.is-open').forEach(function (openCol) {
        if (openCol !== col) {
          openCol.classList.remove('is-open');
          var otherTrigger = openCol.querySelector('.accordion-trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }
      });

      col.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });
})();
